import React from "react";

const CalendarIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      id="calendar_icon"
      data-name="calendar"
      {...props}
      width={props.width || "25"}
      height={props.height || "24"}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.7998 11H9.7998V13H7.7998V11ZM7.7998 15H9.7998V17H7.7998V15ZM11.7998 11H13.7998V13H11.7998V11ZM11.7998 15H13.7998V17H11.7998V15ZM15.7998 11H17.7998V13H15.7998V11ZM15.7998 15H17.7998V17H15.7998V15Z"
        fill={props.fill || "#3A8AB9"}
      />
      <path
        d="M5.7998 22H19.7998C20.9028 22 21.7998 21.103 21.7998 20V6C21.7998 4.897 20.9028 4 19.7998 4H17.7998V2H15.7998V4H9.7998V2H7.7998V4H5.7998C4.6968 4 3.7998 4.897 3.7998 6V20C3.7998 21.103 4.6968 22 5.7998 22ZM19.7998 8L19.8008 20H5.7998V8H19.7998Z"
        fill={props.fill || "#3A8AB9"}
      />
    </svg>
  );
};

export default CalendarIcon;
